import { FeeLevelTypeEnum } from '@/constants/enum'
import { FeeLevelModel, FeeRateDto } from '@/services/apis/tx/models'
import { RuleRegExp } from './validator'

type FEE_FIELD = keyof FeeRateDto
const FEE_EXPRESSION_REPLACED_KEYS: FEE_FIELD[] = [
  'fee',
  'feeRate',
  'maxFee',
  'gasLimit',
  // sui
  'gasBudget',
  // aptos
  'maxGasAmount',
  'gasUnitPrice',
]

let prev = ''

function estimateFee(realFeeRateDto?: FeeRateDto, feeExpression?: string): string {
  if (!realFeeRateDto || !feeExpression) {
    prev = ''
    return prev
  }
  let replacedFeeExPression = feeExpression
  for (let field of FEE_EXPRESSION_REPLACED_KEYS) {
    if (replacedFeeExPression.includes(`{${field}}`)) {
      const fieldValue = realFeeRateDto[field]
      if (!isValidNumber(fieldValue)) {
        return prev
      } else {
        replacedFeeExPression = replacedFeeExPression.replace(`{${field}}`, fieldValue!)
      }
    }
  }

  let res = ''
  try {
    // eslint-disable-next-line no-eval
    res = eval(replacedFeeExPression) || '0'
  } catch (e: any) {
    console.error(
      `estimateFee error. replacedFeeExPression is ${replacedFeeExPression}, realFeeRateDto is ${JSON.stringify(
        realFeeRateDto
      )}, ${e?.message || e} `
    )
  }
  prev = res
  return res
}

export function getLevelFeeRate(feeLevel: FeeLevelTypeEnum, feeLevelModel?: FeeLevelModel) {
  if (!feeLevelModel) {
    return undefined
  }
  let feeRate = feeLevelModel?.middleFeeRate
  switch (feeLevel) {
    case FeeLevelTypeEnum.HIGH:
      return feeLevelModel?.highFeeRate
    case FeeLevelTypeEnum.MIDDLE:
      return feeLevelModel?.middleFeeRate
    case FeeLevelTypeEnum.LOW:
      return feeLevelModel?.lowFeeRate
    default:
      break
  }
  return feeRate
}

export function isValidNumber(num?: string) {
  if (num === null || num === undefined || num === '') {
    return false
  }
  return RuleRegExp.int.test(num) || RuleRegExp.double.test(num)
}

export default {
  estimateFee,
  getLevelFeeRate,
}
